// extracted by mini-css-extract-plugin
export default {"reactPlayer":"Template9_reactPlayer__fADGk","heading":"Template9_heading__Iyy0p","description":"Template9_description__UJRO2"};